/* 하단 탭 · 메뉴 서랍 라인 아이콘 — 레퍼런스 TAB_ICONS.
   같은 문법(24px · stroke 1.6 · currentColor)으로 그리고, 선택된 탭만 채움으로 바꿔 라벨이 사라진
   축소 상태에서도 구분되게 한다. react-icons 에는 이 채움 전환 문법이 없어 직접 그린다. */
import { cn } from '@/core/utils/common'

export type TabKey =
  | 'char'
  | 'story'
  | 'ranking'
  | 'explore'
  | 'chats'
  | 'mission'
  | 'my'
  | 'studio'
  | 'menu'

const FILL =
  'fill-none group-aria-[current=page]:fill-current group-aria-[current=page]:stroke-none'

export default function TabIcon({ k }: { k: TabKey }) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="size-6 fill-none stroke-current [stroke-linecap:round] [stroke-linejoin:round] [stroke-width:1.6] over10:size-4.25"
    >
      {/* 홈 — 지붕 아래 문 하나 */}
      {k === 'char' && (
        <path
          className={FILL}
          d="M4.6 10.4 12 4.6l7.4 5.8v8.2a1 1 0 0 1-1 1h-3.8v-5.4H9.4v5.4H5.6a1 1 0 0 1-1-1z"
        />
      )}
      {/* 랭킹 — 트로피(잔만 채운다) */}
      {k === 'ranking' && (
        <>
          <path className={FILL} d="M7.6 4.8h8.8v4.6a4.4 4.4 0 0 1-8.8 0z" />
          <path d="M7.6 6.4H5.4a2.4 2.4 0 0 0 2.5 3.4M16.4 6.4h2.2a2.4 2.4 0 0 1-2.5 3.4M12 13.8v3.4M8.6 19.2h6.8" />
        </>
      )}
      {/* 메뉴 — 줄 셋. 페이지가 아니라 서랍을 여는 버튼이라 채움 전환이 없다 */}
      {k === 'menu' && <path d="M4.8 7h14.4M4.8 12h14.4M4.8 17h14.4" />}
      {k === 'story' && (
        <>
          <path
            className={FILL}
            d="M11.2 7.2C9.6 5.9 7.4 5.2 4.8 5.2v11.4c2.6 0 4.8.7 6.4 2z"
          />
          <path
            className={FILL}
            d="M12.8 7.2c1.6-1.3 3.8-2 6.4-2v11.4c-2.6 0-4.8.7-6.4 2z"
          />
        </>
      )}
      {/* 탐색 — 세로 화면(릴스) 안 재생 표시. 선택되면 화면을 채우고 재생 표시는 구멍(evenodd)으로 남긴다 */}
      {k === 'explore' && (
        <path
          className={cn(FILL, '[fill-rule:evenodd]')}
          d="M8.4 3.8h7.2a2.8 2.8 0 0 1 2.8 2.8v10.8a2.8 2.8 0 0 1-2.8 2.8H8.4a2.8 2.8 0 0 1-2.8-2.8V6.6a2.8 2.8 0 0 1 2.8-2.8zM10.6 9.4l4.2 2.6-4.2 2.6z"
        />
      )}
      {k === 'chats' && (
        <path
          className={FILL}
          d="M5.6 4.6h12.8a1.8 1.8 0 0 1 1.8 1.8v7.4a1.8 1.8 0 0 1-1.8 1.8H10l-4.6 3.6v-3.6a1.8 1.8 0 0 1-1.6-1.8V6.4a1.8 1.8 0 0 1 1.8-1.8z"
        />
      )}
      {/* 미션 — 과녁(가운데 원만 채운다) */}
      {k === 'mission' && (
        <>
          <circle cx="12" cy="12" r="7.6" />
          <circle cx="12" cy="12" r="4.2" />
          <circle className={FILL} cx="12" cy="12" r="1.4" />
        </>
      )}
      {k === 'studio' && (
        <path
          className={FILL}
          d="M15.6 4.8a2 2 0 0 1 2.8 0l.8.8a2 2 0 0 1 0 2.8L9 18.6l-4.2 1 1-4.2z"
        />
      )}
      {k === 'my' && (
        <>
          <circle cx="12" cy="12" r="8.8" />
          <circle className={FILL} cx="12" cy="10" r="2.6" />
          <path className={cn(FILL)} d="M6.8 18.8a5.4 5.4 0 0 1 10.4 0z" />
        </>
      )}
    </svg>
  )
}
